var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGifType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.565.705a2.918 2.918 0 012.919 2.918v8.754a2.918 2.918 0 01-2.919 2.918H4.434a2.918 2.918 0 01-2.918-2.918V3.623A2.918 2.918 0 014.434.705h13.131z",
    stroke: "#575757",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.987 8.365h1.824v1.094c0 .806-.653 1.46-1.46 1.46H5.894c-.806 0-1.46-.654-1.46-1.46V6.541c0-.806.654-1.46 1.46-1.46h1.459c.54 0 1.011.294 1.264.73M11.364 5.082v5.836M13.918 10.918V5.082h3.648M13.918 8h2.918",
    stroke: "#575757",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgGifType;